import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

import { isSignedIn } from '@/features/auth/lib/session';

export function RequireAuth({ children }: { readonly children: ReactNode }) {
  const location = useLocation();
  if (!isSignedIn()) {
    // Drop ?redirect= when entering on /: there's no meaningful target to bounce back to.
    const target = `${location.pathname}${location.search}`;
    if (location.pathname === '/') {
      return <Navigate to="/sign-in" replace />;
    }
    return <Navigate to={`/sign-in?redirect=${encodeURIComponent(target)}`} replace />;
  }
  return <>{children}</>;
}
